import '../static/PanelList.css';
import React__default, { useState, useRef, memo, useMemo } from "react";
import { a as SectionWrap } from "./SectionWrap.DExzuSui.mjs";
import { b as SectionHeader } from "./SectionHeader.VCo9GnTI.mjs";
import clsx from "clsx";
import { u as useReducedMotion } from "./useReducedMotion.BDSQ_zcf.mjs";
import { u as useBetterMediaQuery } from "./useBetterMediaQuery.xTM_WrtF.mjs";
import { s as sword, b as breakpoints } from "./sword.DtiKVPhx.mjs";
import { u as useIntersectionObserver } from "./useIntersectionObserver.DFMFKeB4.mjs";
const panel = `_panel_a86afc4`;
const alternate = `_alternate_517c6c2`;
const panelContent = `_panelContent_1593d3d`;
const contentPanel = `_contentPanel_c28aa0a`;
const left = `_left_d3ec723`;
const right = `_right_c0cb0e3`;
const intersectionAnchor = `_intersectionAnchor_55735fe`;
const wrapPanel = `_wrapPanel_e322241`;
const mediaSticky = `_mediaSticky_cb4ba2f`;
const mediaStickyContainer = `_mediaStickyContainer_0cea948`;
const mediaStickyContent = `_mediaStickyContent_a7f8339`;
const panelMedia = `_panelMedia_734ff0a`;
const stickyImage = `_stickyImage_4ac6031`;
const visible = `_visible_701b9ef`;
const hiddenImage = `_hiddenImage_7aa1f47`;
const contain = `_contain_1c0c67a`;
const cover = `_cover_0f0bd7b`;
const mediaRatio11 = `_mediaRatio11_be92628`;
const mediaRatio21 = `_mediaRatio21_c065f3c`;
const mediaRatio32 = `_mediaRatio32_cd62f91`;
const mediaRatio169 = `_mediaRatio169_69696c4`;
const contentLeft = `_contentLeft_b4e6132`;
const contentRight = `_contentRight_1a04440`;
const contentSticky = `_contentSticky_368bda8`;
const contentMediaSticky = `_contentMediaSticky_ae30e55`;
const _default = `_default_b4cbd26`;
const styles = { panel, alternate, panelContent, contentPanel, left, right, intersectionAnchor, wrapPanel, mediaSticky, mediaStickyContainer, mediaStickyContent, panelMedia, stickyImage, visible, hiddenImage, contain, cover, mediaRatio11, mediaRatio21, mediaRatio32, mediaRatio169, contentLeft, contentRight, contentSticky, contentMediaSticky, "default": _default };
const PanelContent = ({
  item,
  index,
  stickyImage: stickyImage2 = false,
  onVisibilityChange
}) => {
  const [run, setRun] = useState(false);
  const ref = useRef(null);
  const refLarge = useRef(null);
  const isLarge = useBetterMediaQuery(
    `(min-width: ${sword.breakpoints.minLg})`
  );
  useIntersectionObserver(
    (entry) => {
      if (entry.isIntersecting && onVisibilityChange && !run) {
        onVisibilityChange(index);
        setRun(isLarge ? false : true);
      }
    },
    isLarge ? refLarge : ref,
    {
      root: null,
      rootMargin: isLarge && index !== 0 ? "-50% 0px -50% 0px" : "-10% 0px 0px 0px",
      threshold: 0
    }
  );
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: styles.intersectionAnchor, ref }), /* @__PURE__ */ React__default.createElement(
    "div",
    {
      "data-ui-panel-list-content": true,
      className: clsx(styles.panelContent, {
        [styles.stickyImage]: stickyImage2
      }),
      "data-testid": "panelContent",
      ref: refLarge
    },
    /* @__PURE__ */ React__default.createElement(
      SectionHeader,
      {
        as: "div",
        xAlign: "left",
        titleSize: "2xl",
        titleSeoLevel: "h2",
        title: item.title,
        description: item.description,
        descriptionAs: "div",
        label: item.label,
        solution: item.solution,
        textLink: item.textLink
      }
    )
  ));
};
const PanelMediaInner = ({
  media,
  visible: visible2 = false,
  stickyImage: stickyImage2 = false,
  hiddenImage: hiddenImage2 = false,
  mediaFit = "contain"
}) => {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      "data-ui": "panel-list-media",
      "data-testid": "panel-media",
      className: clsx(styles.panelMedia, {
        [styles.visible]: visible2,
        [styles.stickyImage]: stickyImage2,
        [styles.hiddenImage]: hiddenImage2,
        [styles[mediaFit]]: mediaFit
      })
    },
    media
  );
};
const PanelMedia = memo(PanelMediaInner);
const PanelListDefault = ({
  panelList,
  direction,
  onVisibilityChange,
  stickyImage: stickyImage2 = false
}) => {
  const prefersReducedMotion = useReducedMotion();
  const [visibleIndex, setVisibleIndex] = useState(-1);
  const [animatedIndexes, setAnimatedIndexes] = useState([]);
  const isLarge = useBetterMediaQuery(`(min-width: ${breakpoints.minLg})`);
  const ref = useRef(null);
  const isSticky = useMemo(
    () => !prefersReducedMotion && stickyImage2 && isLarge && direction === "default",
    [direction, stickyImage2, isLarge, prefersReducedMotion]
  );
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.wrapPanel, ref }, panelList.map(
    ({ mediaRatio = "1:1", mediaFit = "contain", ...item }, i) => {
      var _a;
      return /* @__PURE__ */ React__default.createElement(
        "div",
        {
          className: clsx(
            styles.panel,
            styles[`mediaRatio${(isSticky ? "1:1" : mediaRatio).replace(":", "")}`],
            {
              [styles[direction]]: direction,
              [styles.stickyImage]: stickyImage2
            }
          ),
          key: i,
          "data-testid": "panel",
          "data-ui": "panel-list-panel"
        },
        /* @__PURE__ */ React__default.createElement(
          PanelContent,
          {
            item,
            index: i,
            onVisibilityChange: (index) => {
              setVisibleIndex(index);
              if (onVisibilityChange) {
                onVisibilityChange(index);
              }
              if (!isSticky && !animatedIndexes.includes(i)) {
                setAnimatedIndexes((prev) => [...prev, i]);
              }
            }
          }
        ),
        isSticky && i === 0 ? /* @__PURE__ */ React__default.createElement("div", { className: styles.mediaSticky, "data-testid": "mediaSticky" }, /* @__PURE__ */ React__default.createElement(
          PanelMedia,
          {
            media: item.media,
            visible: false,
            hiddenImage: stickyImage2,
            mediaFit
          }
        ), /* @__PURE__ */ React__default.createElement(
          "div",
          {
            className: styles.mediaStickyContainer,
            style: { height: `${(_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.clientHeight}px` }
          },
          /* @__PURE__ */ React__default.createElement("div", { className: styles.mediaStickyContent }, panelList.map((item2, i2) => /* @__PURE__ */ React__default.createElement(
            PanelMedia,
            {
              key: i2,
              media: item2.media,
              stickyImage: stickyImage2,
              visible: visibleIndex === i2,
              mediaFit: item2.mediaFit
            }
          )))
        )) : /* @__PURE__ */ React__default.createElement(
          PanelMedia,
          {
            media: item.media,
            hiddenImage: isSticky,
            visible: !stickyImage2 || visibleIndex === i || animatedIndexes.includes(i),
            mediaFit
          }
        )
      );
    }
  ));
};
const DIRECTIONS = ["default", "alternate", "left"];
const PanelList = ({
  sectionHeader,
  panelList,
  direction = "default",
  onVisibilityChange,
  scrollBehavior = "default",
  ...props
}) => {
  const stickyImage2 = useMemo(
    () => scrollBehavior === "stickyImage",
    [scrollBehavior]
  );
  if (!panelList || (panelList == null ? void 0 : panelList.length) < 1)
    return null;
  return /* @__PURE__ */ React__default.createElement(SectionWrap, { ...props, "data-ui-panel-list": true, "data-testid": "ui-panel-list" }, sectionHeader && /* @__PURE__ */ React__default.createElement(SectionHeader, { ...sectionHeader }), /* @__PURE__ */ React__default.createElement(
    PanelListDefault,
    {
      panelList,
      direction,
      stickyImage: stickyImage2,
      onVisibilityChange
    }
  ));
};
export {
  DIRECTIONS as D,
  PanelList as P
};
//# sourceMappingURL=PanelList.CEcUu7ip.mjs.map
